import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import Product from '../../components/product/Product';

class CatalogPage extends React.Component {

    state = {
        expandedArr: [],
        manualExpandedArr: []
    }

    componentWillReceiveProps = (nextProps) => {
        const {page: {imgPath, imgId, products}, basket: {items}} = nextProps;

        const basketCatalogNumberArr = items.map(i => {
            return i.catalogNumber
        });

        const expandedArr = products.map(product => {
            //expanded
            const isInBasket = product.variantsProductArr.map(p => {
                return basketCatalogNumberArr.includes(p.catalogNumber);
            });
            if (isInBasket.includes(true)) {
                return product.catalogNumber;
            }
            return;

        });
        
        //arr is with undefined values
        const expandedFilteredArr = expandedArr.filter(function (el) {
            return el != null;
        });

        this.setState({expandedArr: [...expandedFilteredArr,...this.state.manualExpandedArr]});
    }

    handleShowVariants = (catalogNumber) => {
        if (!this.state.expandedArr.includes(catalogNumber)) {
            this.setState({
                expandedArr: [...this.state.expandedArr, catalogNumber],
                manualExpandedArr: [...this.state.manualExpandedArr, catalogNumber]
            });
        }
    }
    
    handleHideVariants = (catalogNumber) => {
        
        this.setState({
            expandedArr: this.state.expandedArr.filter(i => i !== catalogNumber),
            manualExpandedArr: this.state.manualExpandedArr.filter(i => i !== catalogNumber)
        });
    }

    renderProduct = (product) => {

        const {props: {basket: {items}}, handleShowVariants} = this;

        const basketItemArr = items.filter(i => i.catalogNumber === product.catalogNumber);
        const qty = basketItemArr.length > 0 ? basketItemArr[0].qty : 0;

        return <Product key={product.id} qty={qty} product={product} handleShowVariants={handleShowVariants} />;
    }

    render() {
        const {props: {page: {imgPath, imgId, products}}, renderProduct, handleHideVariants} = this;

        return (
                <React.Fragment>
                    {products.map(product => {
                        if( product.variantsProductArr.length !== 0 ){
                            return product.variantsProductArr.map(p => {
                                return <a key={p.id} name={p.catalogNumber}></a>
                            })
                        } else {
                            return <a key={product.id} name={product.catalogNumber}></a>
                        }
                    })}
                    <div className="row">
                        <div className="col-md-12 ">
                            <a name={`img-${imgId}`}></a>
                            <LazyLoadImage  
                                width="628" 
                                height="905"
                                className="main-img img-responsive"
                                src={`/pictures/${imgPath}`}
                                alt={`${imgPath}`} /> 
                            <a name={`products-${imgId}`}></a>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 ">
                            <ul className="product-list">
                                {products.map(product => {
                                    //expanded
                                    if (product.variantsProductArr.length !== 0 && this.state.expandedArr.includes(product.catalogNumber)) {
                                        return (
                                            <li key={product.id} className="group" >
                                                <ul> 
                                                <li className="groupName">
                                                    <h4>
                                                        {product.groupName} 
                                                        <a onClick={e => handleHideVariants(product.catalogNumber)} className="closeBtn"><span className="glyphicon glyphicon-remove "></span></a>
                                                    </h4>
                                                </li>
                                                {product.variantsProductArr.map(p => {
                                                    return renderProduct(p)
                                                })}
                                                </ul>
                                            </li>
                                           );
                                    }
                                    
                                    //not expanded    
                                    return renderProduct(product);
                                })}
                            </ul>      
                        </div>        
                    </div>
                </React.Fragment>
                );
    }

}

const mapStateToProps = (state) => ({
    basket: state.basket
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CatalogPage);

